// extracted by mini-css-extract-plugin
module.exports = {"main":"Navigation-module__main___yZoW8","header":"Navigation-module__header___S03yV","body":"Navigation-module__body___2bcNK","footer":"Navigation-module__footer___gLHDz"};